/**
 * Bunny Shield API
 * Bunny.net API for Bunny Shield (WAF, DDoS, Rate Limiting, Bot Detection, Access Lists & API Guardian).

 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * The type of security scheme as defined in the OpenAPI specification.
 */
export type AuthSchemeType = 'ApiKey' | 'Http' | 'OAuth2' | 'OpenIdConnect';

export const AuthSchemeType = {
  ApiKey: 'ApiKey' as AuthSchemeType,
  Http: 'Http' as AuthSchemeType,
  OAuth2: 'OAuth2' as AuthSchemeType,
  OpenIdConnect: 'OpenIdConnect' as AuthSchemeType,
};
